import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import AuthNavigation from '../../components/ui/AuthNavigation';
import RegistrationForm from './components/RegistrationForm';
import SecurityFeatures from './components/SecurityFeatures';
import BenefitsSection from './components/BenefitsSection';

const Register = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="fixed top-0 left-0 right-0 z-50 bg-card shadow-elevation-2">
        <div className="max-w-7xl mx-auto px-16 md:px-24 lg:px-32">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate('/landing-page')}
              className="flex items-center space-x-12 transition-smooth hover:opacity-80"
            >
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
                <Icon name="DollarSign" size={24} color="var(--color-primary)" strokeWidth={2.5} />
              </div>
              <span className="text-lg font-heading font-semibold text-secondary">
                Rovyn Budget
              </span>
            </button>

            <button
              onClick={() => navigate('/login')}
              className="text-sm font-caption text-muted-foreground hover:text-primary transition-smooth min-h-[44px] px-16"
            >
              Already have an account?
            </button>
          </div>
        </div>
      </div>

      <div className="pt-80 pb-48 px-16 md:px-24 lg:px-32">
        <div className="max-w-7xl mx-auto">
          <BenefitsSection />

          <div className="max-w-2xl mx-auto">
            <div className="bg-card rounded-xl shadow-elevation-3 p-24 md:p-32 lg:p-40">
              <div className="text-center mb-32">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-xl mb-16">
                  <Icon name="UserPlus" size={32} color="var(--color-primary)" strokeWidth={2} />
                </div>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-card-foreground mb-8">
                  Create Your Account
                </h1>
                <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto">
                  Start managing your finances with confidence. Join thousands of users who trust Rovyn Budget.
                </p>
              </div>

              <RegistrationForm />

              <AuthNavigation />

              <SecurityFeatures />
            </div>

            <div className="mt-24 text-center">
              <p className="text-xs text-muted-foreground font-caption">
                Protected by industry-standard encryption and security protocols
              </p>
              <div className="flex items-center justify-center space-x-16 mt-12">
                <div className="flex items-center space-x-6">
                  <Icon name="Shield" size={16} color="var(--color-success)" />
                  <span className="text-xs text-muted-foreground">SSL Secured</span>
                </div>
                <div className="flex items-center space-x-6">
                  <Icon name="Lock" size={16} color="var(--color-success)" />
                  <span className="text-xs text-muted-foreground">256-bit Encryption</span>
                </div>
                <div className="flex items-center space-x-6">
                  <Icon name="CheckCircle" size={16} color="var(--color-success)" />
                  <span className="text-xs text-muted-foreground">GDPR Compliant</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;